import { useState } from "react";
import BankVerification from "./BankVerification";
import ConfirmPaymentSchedule from "./ConfirmPaymentSchedule";
import EMandateStepper from "./EMandateStepper";
import SingleApplicant from "./SingleApplicant";
import cssClasses from "./EMandate.module.css";
import SplitOption from "./SplitOption";
import { useLocation } from "react-router-dom";

const EMandateSplit = () => {
  const location = useLocation();
  const allotment = location.state?.allotment;
  const totalMandateAmount = location.state?.totalMandateAmount || 0;
  const bookingId = location.state?.bookingId;
  const allotmentPaymentId = location.state?.allotmentPaymentId;

  console.log("allotment in emandate split --->", allotment);

  const [activeStep, setActiveStep] = useState(1);

  // ✅ Shared data across steps
  const [formData, setFormData] = useState({
    splitOption: null,
    applicant: null,
    bankDetails: null,
  });

  return (
    <div className={cssClasses.pageWrapper}>
      <EMandateStepper activeStep={activeStep} />

      {/* STEP 1 */}
      {activeStep === 1 && (
        <SplitOption
          allotment={allotment}
          totalMandateAmount={totalMandateAmount}
          bookingId={bookingId}
          allotmentPaymentId={allotmentPaymentId}
          onNext={(splitData) => {
            setFormData((prev) => ({
              ...prev,
              splitOption: splitData,
            }));
            setActiveStep(2);
          }}
        />
      )}

      {/* STEP 2 */}
      {activeStep === 2 && <SingleApplicant />}

      {/* STEP 3 */}
      {activeStep === 3 && (
        <BankVerification
          applicant={formData.applicant}
          onBack={() => setActiveStep(2)}
          onSubmit={(bankDetails) => {
            setFormData((prev) => ({
              ...prev,
              bankDetails,
            }));
            setActiveStep(4);
          }}
        />
      )}

      {/* STEP 4 */}
      {activeStep === 4 && <ConfirmPaymentSchedule data={formData} />}
    </div>
  );
};

export default EMandateSplit;
